/**
 * NyumbaSuite's real contact details, one place, per the 2026-08-25 contact/
 * footer brief. The web header, footer and WhatsApp button, and the app's
 * Help & Support screen, all read from here rather than each holding its own
 * copy — a changed number is a one-line edit, not a grep across files hoping
 * none were missed.
 *
 * ONE NUMBER, for calls and WhatsApp alike (2026-09-17, on direct
 * instruction): 0181 662 999 replaced both earlier lines — 0782 908 106 for
 * calls and 0714 325 324 for WhatsApp — and the "Alternative" number was
 * removed everywhere it showed. The tel: and wa.me links are derived from the
 * same constant rather than stored beside it: a click-to-chat link is just the
 * number in a different format (country code, no leading zero, no punctuation),
 * so the two can never silently disagree.
 *
 * The footer's third contact line was the website URL, on an earlier brief
 * that was explicit it must never be shown as if it were an email. Replaced
 * 2026-09-09 on direct instruction: the footer now shows the support mailbox
 * instead. That mailbox is real — see PMS Hostinger Mailboxes in memory.
 */

const PRIMARY_PHONE = '0181 662 999';
const SUPPORT_EMAIL = 'admin@nyumbasuite.com';

/** Kenyan local format (0XXX XXX XXX or 07XXXXXXXX) to E.164, for tel:/wa.me links. */
export function toE164(local: string): string {
  const digits = local.replace(/\D/g, '');
  if (digits.startsWith('254')) return `+${digits}`;
  return '+254' + digits.replace(/^0/, '');
}

/** A wa.me click-to-chat link for any Kenyan number, with an optional prefilled message. */
export function whatsappLink(phone: string, text?: string): string {
  const number = toE164(phone).slice(1);
  return text ? `https://wa.me/${number}?text=${encodeURIComponent(text)}` : `https://wa.me/${number}`;
}

export const CONTACT = {
  primaryPhone: PRIMARY_PHONE,
  primaryTel: `tel:${toE164(PRIMARY_PHONE)}`,
  whatsapp: whatsappLink(PRIMARY_PHONE),
  email: SUPPORT_EMAIL,
  emailTo: `mailto:${SUPPORT_EMAIL}`,
  tiktok: 'https://www.tiktok.com/@nyumbasuite_254',
  instagram: 'https://www.instagram.com/nyumbasuite/',
  facebook: 'https://www.facebook.com/profile.php?id=61593456735618',
  x: 'https://x.com/nyumbasuite',
  linkedin: 'https://www.linkedin.com/in/nyumbasuite-solutions-limited-b6b238438/',
};
